import { useRef as P, useState as C, useCallback as l, useEffect as E } from "react";
import d from "../../../utils/getTransitionDuration.js";
import b from "./usePopoverContext.js";
const O = () => {
  const {
    context: v,
    layerMode: o,
    onCloseEnd: n,
    onCloseStart: c,
    onOpenEnd: r,
    onOpenStart: u,
    refs: { floating: e }
  } = b(), { open: s, isPositioned: p } = v, t = P(s ? "open" : "closed"), [m, f] = C(s), i = l(() => {
    o === "native" && e.current?.hidePopover(), f(!1), n?.();
  }, [o, e, n]), T = l((a) => {
    const { target: h, propertyName: y } = a;
    h === e.current && y === "opacity" && (t.current === "closed" ? i() : r?.());
  }, [e, n, r]);
  return E(() => {
    s ? p ? (o === "native" && e.current?.showPopover(), d(e.current, "opacity") > 0 || r?.()) : (u?.(), f(!0), t.current = "open") : t.current === "open" && (c?.(), t.current = "closed", d(e.current, "opacity") > 0 || i());
  }, [s, p, e, u, r, c, n, o, i]), { status: t, visible: m, onTransitionEnd: T };
};
export {
  O as default
};
